import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, Typography, Alert, Divider, Spin, Row, Col } from "antd";
import { UserOutlined, LockOutlined, SafetyOutlined, TeamOutlined, CrownOutlined, ShopOutlined } from "@ant-design/icons";
import { loginEmployee } from "../../../services/employeeService";
import "../LoginPage.css";

const { Title, Text, Link } = Typography;

const EmployeeLoginPage = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userType");
    localStorage.removeItem("userName");
  }, []);

  const handleLogin = async (values) => {
    setError("");
    setLoading(true);

    try {
      const employeeLoginRequest = {
        username: values.username,
        password: values.password
      };

      const response = await loginEmployee(employeeLoginRequest);

      const { token, refreshToken, id, userType, userName } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("userId", id);
      localStorage.setItem("userType", userType);
      localStorage.setItem("userName", userName);

      window.location.href = "/employee/order-items";
    } catch (error) {
      console.error("Employee login failed:", error);
      if (error.response && error.response.status === 401) {
        setError("Kullanıcı adı veya şifre hatalı. Lütfen tekrar deneyiniz.");
      } else {
        setError("Giriş sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
      }
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = (type) => {
    switch(type) {
      case 'company':
        window.location.href = '/login';
        break;
      case 'admin':
        window.location.href = '/admin/login';
        break;
      default:
        break;
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card employee-login-card" bordered={false}>
        <div className="logo-container">
          <img src="/img/icon-512-maskable.png" alt="Siparify Employee" className="company-logo" />
        </div>

        <Title level={2} className="login-title">Giriş Yap</Title>

        {/* User Type Selection */}
        <div className="user-type-selection" style={{ marginBottom: 24 }}>
          <Text type="secondary" style={{ display: 'block', marginBottom: 12, textAlign: 'center' }}>
            Giriş tipinizi seçin
          </Text>
          <Row gutter={8}>
            <Col span={8}>
              <Button 
                type="default" 
                block 
                icon={<ShopOutlined />}
                onClick={() => navigateToLogin('company')}
                style={{ height: 45 }}
              >
                Şirket
              </Button>
            </Col>
            <Col span={8}>
              <Button 
                type="default" 
                block 
                icon={<TeamOutlined />}
                style={{ 
                  height: 45,
                  border: '2px solid #52c41a',
                  color: '#52c41a',
                  backgroundColor: '#f6ffed'
                }}
                disabled
              >
                Çalışan
              </Button>
            </Col>
            <Col span={8}>
              <Button 
                type="default" 
                block 
                icon={<CrownOutlined />}
                onClick={() => navigateToLogin('admin')}
                style={{ height: 45 }}
              >
                Yönetici
              </Button>
            </Col>
          </Row>
        </div>

        <Divider plain><Text type="secondary">Çalışan Girişi</Text></Divider>

        {error && <Alert message={error} type="error" showIcon className="error-alert" />}

        <Form
          form={form}
          name="employee_login"
          onFinish={handleLogin}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="username"
            label="Kullanıcı Adı"
            rules={[{ required: true, message: "Lütfen kullanıcı adınızı giriniz" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Kullanıcı adınızı girin"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Şifre"
            rules={[{ required: true, message: "Lütfen şifrenizi giriniz" }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Şifrenizi girin"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item className="forgot-password-container">
            <Link href="/employee/forgot-password" className="forgot-password-link">
              Şifremi Unuttum
            </Link>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-button employee-login-button"
              block
              icon={loading ? null : <SafetyOutlined />}
              disabled={loading}
            >
              {loading ? <Spin size="small" /> : "Çalışan Olarak Giriş"}
            </Button>
          </Form.Item>
        </Form>

        <Divider plain><Text type="secondary">veya</Text></Divider>

        <div className="help-text">
          Giriş yapmakta sorun mu yaşıyorsunuz? <Link href="mailto:iletisim@siparify.com">Destek Ekibi</Link> ile iletişime geçin
        </div>

        <div className="copyright-footer">
          © 2025 Siparify | Çalışan Portalı
        </div>
      </Card>
    </div>
  );
};

export default EmployeeLoginPage;